<template>
    <b-card>

        <div class="row">
    <div class="col">
    <h5 class="card-title text-uppercase text-muted mb-0">Pre-order</h5>
    <span class="h2 font-weight-bold mb-0">25 sales</span>
    </div>
    <div class="col-auto">
    <div class="icon icon-shape bg-gradient-info text-white rounded-circle shadow">
    <i class="ni ni-chart-bar-32"></i>
    </div>
    </div>
    </div>
    <p class="mt-3 mb-0 text-sm">
    
    <span class="text-nowrap">Pre-Order start: 01.01.2025</span>
    </p>


      
    </b-card>

</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'

export default {
    name: "presale-results-small",
    components: {
    },
    data() {
        return {
            loading: false,
            currentBook: [],
        };
    },
    props: {
        photoBookId: '',
        hasQrCode: false,
    },
    methods: {
        retrieveBook() {
            this.loading = true;
            this.$api.getPhotoBook(this.photoBookId)
                .then((response) => {
                    console.log(response);
                    this.currentBook = response.data;
                    console.log(this.currentBook);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false
                });
        },
        formatDate(date) {
            return moment(date).format("Do MMM YYYY")
        },
        async copyURL(mytext) {
            try {
                
            await navigator.clipboard.writeText(mytext);
            alert('Copied');
            } catch($e) {
            alert('Cannot copy');
            alert($e);
            }
        }
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount' }),
        commentsLoaded: function () {
            return this.currentBook ? true : false;
        }
    },
    mounted() {
    //    this.retrieveBook();
    },
};
</script>
<style></style>
<!--
<div class="card card-stats">

    <div class="card-body">
    <div class="row">
    <div class="col">
    <h5 class="card-title text-uppercase text-muted mb-0">Performance</h5>
    <span class="h2 font-weight-bold mb-0">49,65%</span>
    </div>
    <div class="col-auto">
    <div class="icon icon-shape bg-gradient-info text-white rounded-circle shadow">
    <i class="ni ni-chart-bar-32"></i>
    </div>
    </div>
    </div>
    <p class="mt-3 mb-0 text-sm">
    <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
    <span class="text-nowrap">Since last month</span>
    </p>
    </div>
    </div>
     -->